export default __webpack_public_path__ + "locales/vi/PaymentsEnterprise.json?hash=b19816fb8ef6eb79f6a9376ae6c0aba0";